import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import { requireStaticImageAtomComponent } from "@vfit/shared/data-access";
import { fonts, pxToFontSize } from "@vfit/shared/themes";
import { useDeviceType } from "@vfit/shared/hooks";
import { AccordionNavigationType } from "@vfit/shared/models";
import { FooterTopContainer, FooterBottomContainer, FooterBottomContent, FooterLinks, FooterLinksCol, FooterContainer, FooterCopyright, FooterMobileLinks, FooterMobileLink, FooterButton, FooterAppWrapper } from "./footer.style";
import AccordionNavigation from "../AccordionNavigation/accordionNavigation";
import { EVENTS_TYPE, ONCLICK_EVENTS } from "./footer.utils";
var Footer = function(param) {
    var footer = param.footer, subChildren = param.subChildren;
    var ref = useDeviceType(), isDesktop = ref.isDesktop, isMobile = ref.isMobile;
    var app = footer.app, socials = footer.socials, footerLinks = footer.footerLinks, copyright = footer.copyright, mobileLinks = footer.mobileLinks;
    var accordionNavigationConfig = {
        backgroundColor: "#0d0d0d",
        borderColor: "#fff",
        textColor: "#fff",
        fontFamily: fonts.regular,
        fontSize: pxToFontSize(20),
        fontWeight: 700,
        iconColor: "#fff",
        fontSizeLinks: pxToFontSize(16),
        fontWeightLinks: 400,
        fontFamilyLinks: fonts.regular,
        colorLinks: "#fff",
        highlightColor: "#e60000",
        enableHighlight: true
    };
    var handleRedirect = function(url) {
        return function() {
            if (url) window.open(url, "_blank");
        };
    };
    var links = function() {
        return footerLinks && /*#__PURE__*/ _jsx(FooterLinks, {
            children: Children.toArray(footerLinks.map(function(f) {
                var ref;
                /*#__PURE__*/ return _jsxs(FooterLinksCol, {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: f.category
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: Children.toArray((ref = f.links) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                return(// eslint-disable-next-line jsx-a11y/anchor-is-valid
                                /*#__PURE__*/ _jsx("a", {
                                    onClick: function(evt) {
                                        var url = item.url;
                                        // handlerTrackEvent(item.category);
                                        if (url && EVENTS_TYPE.includes(url)) {
                                            evt.preventDefault();
                                            ONCLICK_EVENTS[url]();
                                        }
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    href: item.url,
                                    children: item.category
                                }));
                            }))
                        })
                    ]
                });
            }))
        });
    };
    var linksMobile = function() {
        return footerLinks && /*#__PURE__*/ _jsx(AccordionNavigation, {
            links: footerLinks,
            config: accordionNavigationConfig,
            // handlerTrackEvent={handlerTrackEvent}
            accordionNavigationType: AccordionNavigationType.FOOTER
        });
    };
    var footerSocials = function() {
        var ref, ref1;
        var ref2 = (socials === null || socials === void 0 ? void 0 : socials.logo) || {
            alt: "",
            image: ""
        }, socialAltImg = ref2.alt, imageSocial = ref2.image;
        var ref3 = requireStaticImageAtomComponent(imageSocial), srcSocial = ref3.src, srcSetSocial = ref3.srcSet;
        return (socials === null || socials === void 0 ? void 0 : socials.title) && /*#__PURE__*/ _jsxs(FooterBottomContent, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: socials.title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: Children.toArray((ref = socials.elements) === null || ref === void 0 ? void 0 : ref.map(function(element) {
                                var image = element.image, alt = element.alt, url = element.url;
                                var ref = requireStaticImageAtomComponent(image), src = ref.src, srcSet = ref.srcSet;
                                return /*#__PURE__*/ _jsx(FooterButton, {
                                    marginRight: 14,
                                    type: "button",
                                    onClick: handleRedirect(url),
                                    children: /*#__PURE__*/ _jsx("img", {
                                        width: 30,
                                        alt: alt || "",
                                        srcSet: srcSet,
                                        src: src
                                    })
                                });
                            }))
                        })
                    ]
                }),
                socials.logo && /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(FooterButton, {
                        type: "button",
                        onClick: handleRedirect((ref1 = socials.logo) === null || ref1 === void 0 ? void 0 : ref1.url),
                        children: /*#__PURE__*/ _jsx("img", {
                            width: 48,
                            alt: socialAltImg || "",
                            srcSet: srcSetSocial,
                            src: srcSocial
                        })
                    })
                })
            ]
        });
    };
    var footerApp = function() {
        var ref;
        return (app === null || app === void 0 ? void 0 : app.message) && /*#__PURE__*/ _jsxs(FooterTopContainer, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: app.message
                    })
                }),
                /*#__PURE__*/ _jsx(FooterAppWrapper, {
                    height: 51,
                    children: Children.toArray((ref = app.logos) === null || ref === void 0 ? void 0 : ref.map(function(logo, indexLogo) {
                        var image = logo.image, alt = logo.alt, url = logo.url;
                        var ref = requireStaticImageAtomComponent(image), src = ref.src, srcSet = ref.srcSet;
                        return /*#__PURE__*/ _jsx(FooterButton, {
                            marginRight: indexLogo !== app.logos.length - 1 ? 30 : 0,
                            type: "button",
                            onClick: handleRedirect(url),
                            children: /*#__PURE__*/ _jsx("img", {
                                className: "apps",
                                alt: alt,
                                srcSet: srcSet,
                                src: src
                            })
                        });
                    }))
                })
            ]
        });
    };
    var renderMobileLinks = function() {
        /*#__PURE__*/ return _jsx(FooterMobileLinks, {
            children: Children.toArray(mobileLinks === null || mobileLinks === void 0 ? void 0 : mobileLinks.map(function(mLink, indexLink) {
                return /*#__PURE__*/ _jsx(FooterMobileLink, {
                    onClick: function() {
                        window.open(mLink.url || "", "_blank");
                    },
                    borderLeft: indexLink > 0,
                    children: /*#__PURE__*/ _jsx("span", {
                        children: mLink.category
                    })
                });
            }))
        });
    };
    return /*#__PURE__*/ _jsxs(FooterContainer, {
        children: [
            footerApp(),
            subChildren || null,
            /*#__PURE__*/ _jsxs(FooterBottomContainer, {
                children: [
                    footerSocials(),
                    isDesktop ? links() : linksMobile(),
                    copyright && /*#__PURE__*/ _jsx(FooterCopyright, {
                        children: /*#__PURE__*/ _jsx("span", {
                            children: copyright
                        })
                    }),
                    isMobile && mobileLinks && renderMobileLinks()
                ]
            })
        ]
    });
};
export default Footer;
